module.exports = __webpack_public_path__ + "img/social-capital.cd0298d4.svg";